import './index.css'
import { Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Layout from './Layout';
import Home from './Home';
import About from './About';
import Blogs from './Blogs';
import PMMCPage from './PMMCPage';
import WMTCPage from './WMTCPage';
import PGEOPage from './PGEOPage';
import PrivacyPolicy from './PrivacyPolicy';
import TermsOfService from './TermsOfService';
import CookiePolicy from './CookiePolicy';
import ScrollToTop from './components/ScrollToTop';

const testimonials = [
  {
    name: 'Ayesha Khan',
    text: 'Participating in the Math Olympiad changed my life. I made friends and learned so much!',
    img: 'https://randomuser.me/api/portraits/women/68.jpg',
  },
  {
    name: 'Ali Raza',
    text: 'Capstone Pakistan competitions are world-class. I felt proud to represent Pakistan!',
    img: 'https://randomuser.me/api/portraits/men/65.jpg',
  },
  {
    name: 'Sara Ahmed',
    text: 'The Science Bowl was thrilling and inspiring. Highly recommended!',
    img: 'https://randomuser.me/api/portraits/women/65.jpg',
  },
  {
    name: 'Bilal Siddiqui',
    text: 'The support and community at Capstone Pakistan is amazing. I grew so much as a student.',
    img: 'https://randomuser.me/api/portraits/men/68.jpg',
  },
];

const affiliations = [
  // Sample logo URLs (replace with PNGs as needed)
  'https://upload.wikimedia.org/wikipedia/commons/4/4a/Logo_2013_Google.png',
  'https://upload.wikimedia.org/wikipedia/commons/a/ab/Logo_TV_2015.png',
  'https://upload.wikimedia.org/wikipedia/commons/5/51/Facebook_f_logo_%282019%29.svg',
  'https://upload.wikimedia.org/wikipedia/commons/0/08/Netflix_2015_logo.svg',
  'https://upload.wikimedia.org/wikipedia/commons/6/6e/WhatsApp.svg',
];

const flashcards = [
  // Sample team images (replace with real team photos)
  { year: '2023', team: 'Math', img: 'https://images.unsplash.com/photo-1513258496099-48168024aec0?auto=format&fit=crop&w=400&q=80' },
  { year: '2023', team: 'Science', img: 'https://images.unsplash.com/photo-1464983953574-0892a716854b?auto=format&fit=crop&w=400&q=80' },
  { year: '2023', team: 'Literature', img: 'https://images.unsplash.com/photo-1503676382389-4809596d5290?auto=format&fit=crop&w=400&q=80' },
  { year: '2023', team: 'Informatics', img: 'https://images.unsplash.com/photo-1519125323398-675f0ddb6308?auto=format&fit=crop&w=400&q=80' },
  { year: '2022', team: 'Math', img: 'https://images.unsplash.com/photo-1513258496099-48168024aec0?auto=format&fit=crop&w=400&q=80' },
  { year: '2022', team: 'Science', img: 'https://images.unsplash.com/photo-1464983953574-0892a716854b?auto=format&fit=crop&w=400&q=80' },
  { year: '2022', team: 'Literature', img: 'https://images.unsplash.com/photo-1503676382389-4809596d5290?auto=format&fit=crop&w=400&q=80' },
  { year: '2022', team: 'Informatics', img: 'https://images.unsplash.com/photo-1519125323398-675f0ddb6308?auto=format&fit=crop&w=400&q=80' },
];

const blogs = [
  {
    title: 'How to Prepare for National Competitions',
    summary: 'Tips and resources to help you excel in academic contests.',
    date: 'June 2024',
    img: 'https://images.unsplash.com/photo-1465101046530-73398c7f28ca?auto=format&fit=crop&w=400&q=80',
  },
  {
    title: 'Meet the 2023 Pakistan Team',
    summary: 'Get to know the students representing Pakistan on the world stage.',
    date: 'May 2024',
    img: 'https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=400&q=80',
  },
];

const winners = [
  // Sample images of students with certificates
  'https://images.unsplash.com/photo-1517841905240-472988babdf9?auto=format&fit=crop&w=400&q=80',
  'https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?auto=format&fit=crop&w=400&q=80',
  'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=400&q=80',
  'https://images.unsplash.com/photo-1519125323398-675f0ddb6308?auto=format&fit=crop&w=400&q=80',
  'https://images.unsplash.com/photo-1513258496099-48168024aec0?auto=format&fit=crop&w=400&q=80',
  'https://images.unsplash.com/photo-1464983953574-0892a716854b?auto=format&fit=crop&w=400&q=80',
];

function App() {
  return (
    <HelmetProvider>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="blogs" element={<Blogs />} />
          <Route path="competitions/pmmc" element={<PMMCPage />} />
          <Route path="competitions/wmtc" element={<WMTCPage />} />
          <Route path="competitions/pgo" element={<PGEOPage />} />
          <Route path="privacy-policy" element={<PrivacyPolicy />} />
          <Route path="terms-of-service" element={<TermsOfService />} />
          <Route path="cookie-policy" element={<CookiePolicy />} />
        </Route>
      </Routes>
    </HelmetProvider>
  );
}

export default App;
